import { Button } from 'gf-ui-components-mui-lib';
export const IconWithButtonHover = ({ onClick, children, startIcon, fontSize, height, lineHeight, padding, className='' }: any) => {
  return (
    <Button
      sx={{
        fontSize: fontSize ? fontSize : '12px',
        fontWeight: 600,
        backgroundColor: '#FFFFFF !important',
        color: '#333333',
        padding: padding ? padding : '12px 32px',
        borderRadius: '4px',
        ':hover': {
          border: '1px solid #175CE5',
          bosShadow: 'none',
          color: '#175CE5'
        },
        border: '1px solid var(--gray-300, #E6E6E6)',
        height: height ? height : '48px',
        lineHeight: lineHeight ? lineHeight : '32px',
        fontFamily: 'Poppins'
      }}
      id={className ? className : `hover-btn`}
      startIcon={startIcon}
      onClick={onClick}
      children={children}
    />
  );
};

export default IconWithButtonHover;
